/**
 * Created by lari on 08/06/2017.
 */
(function () {
  'use strict';
  angular.module('vcdms.vcdocument')
    .component('documentform', {
      restrict: 'E',
      bindings: {
        document: '<',
        parentsave: '&',
        oncancel: '&'
      },
      templateUrl: 'vcdms/document/documentform-component.tpl.html',
      controllerAs: 'vm',
      controller:
        function () {
          let vm = this;
          vm.save = save;
          vm.cancel = cancel;
          // vm.zipsave = zipsave;
          
          vm.$onInit = function () {
            vm.lastdocument = angular.copy(vm.document);
          };
          
          function save() {
            if (!angular.equals(vm.document, vm.lastdocument)) {
              vm.lastdocument = angular.copy(vm.document);
              vm.parentsave({document: vm.document});
            }
          }
          
          function cancel() {
            vm.document = angular.copy(vm.lastdocument);
            vm.oncancel();
          }
        } // controller
    }); // component

// klammerfriedhof
}());
